import { ENVIRONMENT } from "@daytrip/legacy-config";
import { authLink, retryQueryLink } from "@daytrip/trpc-client-utils";
import { httpLink, loggerLink } from "@trpc/client";
import superjson from "superjson";

import { API_TRPC_URL, VERSION } from "../../config.management";
import { getAuthenticationStore } from "../../domain/authentication/AuthenticationStore.singleton";
import {
    getManagementAuthenticationToken,
    setManagementAuthenticationToken,
    setManagementRefreshToken,
} from "../../utils/authentication/authenticationUtils";

import { apiTrpcReact } from "./apiTrpcReact";
import { apiTrpcRefreshTokenClient } from "./apiTrpcRefreshTokenClient";

export const apiTrpcClient = apiTrpcReact.createClient({
    links: [
        authLink({
            getToken: () => getManagementAuthenticationToken(),
            fetchAccessToken: async () => {
                const tokenPair = await apiTrpcRefreshTokenClient.authentication.refreshUserTokens.mutate({
                    refreshBoth: true,
                });
                return tokenPair;
            },
            onTokenRefreshed: (tokenPair) => {
                setManagementAuthenticationToken(tokenPair.authentication);
                setManagementRefreshToken(tokenPair.refresh);
                getAuthenticationStore().setAuthenticationToken(tokenPair.authentication);
            },
            onRefreshFailed: () => {
                getAuthenticationStore().logout(true);
            },
        }),
        retryQueryLink({
            attempts: 2, // allow 1 retry
        }),
        loggerLink({
            enabled: () => ENVIRONMENT !== "production",
        }),
        httpLink({
            url: API_TRPC_URL,
            transformer: superjson,
            headers() {
                const correlationId = Math.random().toString(36).slice(-8);
                return {
                    Authorization: `Bearer ${getManagementAuthenticationToken()}`,
                    lang: "en",
                    "x-daytrip-client": `management-${VERSION}`,
                    "x-correlation-id": `mgmt${correlationId}`,
                };
            },
        }),
    ],
});
